var CurrencySymbols;
(function (CurrencySymbols) {
    CurrencySymbols["RUB"] = "\u20BD";
    CurrencySymbols["USD"] = "$";
    CurrencySymbols["EUR"] = "\u20AC";
    CurrencySymbols["GBP"] = "\u00A3";
    CurrencySymbols["JPY"] = "\u00A5";
    CurrencySymbols["CHF"] = "\u20A3";
    CurrencySymbols["CNY"] = "\u04B0";
    CurrencySymbols["UAH"] = "\u20B4";
    CurrencySymbols["HKD"] = "$";
    CurrencySymbols["procent"] = "%";
})(CurrencySymbols || (CurrencySymbols = {}));
var Currency;
(function (Currency) {
    Currency["RUB"] = "RUB";
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
    Currency["PROCENT"] = "procent";
})(Currency || (Currency = {}));

export { Currency, CurrencySymbols };
//# sourceMappingURL=currency.js.map
